import {
  api
} from "./api";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface CreateOrderItemInput {
  productId: string;
  quantity: number;
}

export interface CreateOrderInput {
  customerName: string;
  phone: string;
  whatsappNumber: string | null;
  email: string | null;
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  state: string;
  postalCode: string;
  notes: string | null;
  items: CreateOrderItemInput[];
}

export interface CreatedOrderItem {
  id: string;
  productId: string | null;
  productName: string;
  productSlug: string;
  sku: string;
  unitPrice: string;
  quantity: number;
  lineTotal: string;
}

export interface CreatedOrder {
  id: string;
  orderNumber: string;
  customerName: string;
  phone: string;
  whatsappNumber: string | null;
  email: string | null;
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  state: string;
  postalCode: string;
  notes: string | null;
  subtotal: string;
  shippingAmount: string;
  totalAmount: string;
  paymentMethod: string;
  paymentStatus: string;
  orderStatus: string;
  createdAt: string;
  updatedAt: string;
  items: CreatedOrderItem[];
}

export async function createOrder(
  input: CreateOrderInput
): Promise<CreatedOrder> {
  const response =
    await api.post<
      ApiResponse<CreatedOrder>
    >(
      "/orders",
      input
    );

  return response.data.data;
}


export interface ShippingRules {
  flatRate: number;
  freeShippingThreshold: number;
}

export async function getShippingRules():
Promise<ShippingRules> {
  const response =
    await api.get<
      ApiResponse<ShippingRules>
    >(
      "/orders/shipping-rules"
    );

  return response.data.data;
}
